import { FormikContextType } from 'formik';
import { TDocSeries } from 'shared/constants/docs';
import { prettyDate } from 'shared/utils/format';
import { FieldTextField } from 'shared/_ui/form/form-text-field';
import { Box } from '@mui/material';

const LABEL_WIDTH = '7rem';

type SeriesCardProps = {
	formik: FormikContextType<TDocSeries>;
};

export default function SeriesCard({ formik }: SeriesCardProps) {
	return (
		<Box>
			<FieldTextField
				label="ID:"
				value={formik.values._id}
				fullWidth
				labelProps={{ width: LABEL_WIDTH }}
			/>
			<FieldTextField
				label="Created:"
				value={prettyDate(formik.values.created)}
				fullWidth
				labelProps={{ width: LABEL_WIDTH }}
			/>
			<FieldTextField
				label="Type:"
				value={formik.values.seriesType || '—'}
				fullWidth
				labelProps={{ width: LABEL_WIDTH }}
			/>
			<FieldTextField
				label="Playlist level:"
				value={1}
				fullWidth
				labelProps={{ width: LABEL_WIDTH }}
			/>
		</Box>
	);
}
